// Права доступа выдаёт сервер: компания и роль живут в токене, потому что
// правила RTDB и Storage не умеют читать Firestore. Панель после входа
// просит их обновить и забирает свежий токен.
//
// Без этого водитель не видит ничего: ни своих фактур, ни расчётов, ни
// обращений — правила отказывают всем, у кого в токене нет компании.

const FN = 'https://us-central1-godelta-partner-crm.cloudfunctions.net/syncMyClaims';

/**
 * Просит сервер выдать права и обновляет токен.
 *
 * @param {import('firebase/auth').User} user
 * @param {string} [companyId] нужен при первом входе, пока карты доступа нет;
 *        сервер всё равно проверяет, числится ли человек в этой компании.
 */
export const syncClaims = async (user, companyId) => {
    if (!user) return null;

    try {
        const idToken = await user.getIdToken();
        const res = await fetch(FN, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Authorization: `Bearer ${idToken}` },
            body: JSON.stringify(companyId ? { companyId } : {})
        });

        if (!res.ok) return null;
        const claims = await res.json();

        // Свежий токен: иначе выданные права доедут только через час.
        await user.getIdToken(true);
        return claims;
    } catch (e) {
        return null;
    }
};

/** Права уже в токене? */
export const hasClaims = async (user) => {
    if (!user) return false;
    try {
        const { claims } = await user.getIdTokenResult();
        return Boolean(claims.companyId && claims.role);
    } catch (e) {
        return false;
    }
};

export default syncClaims;
